import proptype from 'prop-types';
import {FmlxIcon} from 'fmlx-common-ui';
import {TrayType} from '../../constants/dataEnum';

export default function ProtocolStatus({protocol, isRunning}) {
  const {isTessaraProtocol} = protocol?.protocol || {};

  return (
    <>
      {isRunning && (
        <div className={`running-icon ${protocol.isSelected ? ' selected' : ''} ${isTessaraProtocol ? 'tessara' : ''}`}>
          <FmlxIcon name="PlayCircle" customColor="#3F9243" />
        </div>
      )}
      {protocol?.protocol?.trayType === TrayType.DOUBLE_CADDY && (
        <div className={`double-caddy${protocol.isSelected ? ' selected' : ''}`}>
          <FmlxIcon name="FastDoublePlate" size="xs" customColor="#DB5700" />
        </div>
      )}
      {protocol?.protocol?.trayType === TrayType.HIGH_VOLUME_CADDY && (
        <div className={`high-volume-caddy${protocol.isSelected ? ' selected' : ''}`}>
          <FmlxIcon name="MantisPipette" size="xs" customColor="#006AF5" />
        </div>
      )}
      {isTessaraProtocol && (
        <div className={`tessara-icon ${protocol.isSelected ? ' selected' : ''}`}>
          <FmlxIcon name="FastTessara" size="xs" customColor="#003D5C" />
        </div>
      )}
    </>
  );
}

ProtocolStatus.propTypes = {
  protocol: proptype.object,
  isRunning: proptype.bool,
};

ProtocolStatus.defaultProps = {
  protocol: {},
  isRunning: false,
};
